"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moveOptionToEnd = _interopRequireDefault(require("./moveOptionToEnd"));
var _sortByKey = _interopRequireDefault(require("./sortByKey"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var sortOptions = function sortOptions(_ref) {
  var moveToEndValue = _ref.moveToEndValue,
    _ref$moveToEndValueKe = _ref.moveToEndValueKey,
    moveToEndValueKey = _ref$moveToEndValueKe === void 0 ? 'value' : _ref$moveToEndValueKe,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$sortKey = _ref.sortKey,
    sortKey = _ref$sortKey === void 0 ? 'label' : _ref$sortKey,
    _ref$sortDirection = _ref.sortDirection,
    sortDirection = _ref$sortDirection === void 0 ? 'asc' : _ref$sortDirection;
  return (0, _moveOptionToEnd["default"])({
    options: (0, _sortByKey["default"])({
      options: options,
      sortKey: sortKey,
      sortDirection: sortDirection
    }),
    value: moveToEndValue,
    valueKey: moveToEndValueKey
  });
};
var _default = exports["default"] = sortOptions;